import { Link } from "react-router-dom";
import { ArrowUpRight, Bookmark, Clock3 } from "lucide-react";

export default function ArticleCard({ article, index, saved = false }) {
  return (
    <article className="journal-card" data-testid={`blog-card-${index}`}>
      <Link to={`/blogs/${article.slug}`} className="journal-card-img" data-testid={`blog-card-image-${index}`}>
        <img src={article.image} alt={article.title} loading="lazy" />
        {saved && <span className="saved-flag" data-testid={`blog-saved-flag-${index}`}><Bookmark size={13} fill="currentColor" /></span>}
      </Link>
      <div className="journal-card-body">
        <div className="journal-meta">
          <span className="journal-cat">{article.category}</span>
          {article.date && <span>{article.date}</span>}
          <span className="journal-rt"><Clock3 size={11} /> {article.readingTime} min read</span>
        </div>
        <h3>{article.title}</h3>
        {article.excerpt && <p>{article.excerpt}</p>}
        <Link className="card-link" data-testid={`blog-read-more-${index}`} to={`/blogs/${article.slug}`}>Read article <ArrowUpRight size={15} /></Link>
      </div>
    </article>
  );
}
